import {
  SecurityPoiModel,
  SecurityCategoryModel,
} from "../models/site-security-mapping.model";
import { createAction } from "@ngrx/store";

export const ADD_SECURITY_POIS = createAction(
  "ADD_SECURITY_POIS",
  (securityPois: SecurityPoiModel[]) => ({ securityPois }),
);

export const ADD_SECURITY_CATEGORIES = createAction(
  "ADD_SECURITY_CATEGORIES",
  (securityCategories: SecurityCategoryModel[]) => ({ securityCategories }),
);
